var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tab-thumbnail-switcher-wrapper" }, [
    _c("div", {
      staticClass: "tab-thumbnail-switcher-tablet-left-image",
      style: _vm.getMediaStyle(_vm.sectionSettings.tabletImage, "1000x")
    }),
    _vm._v(" "),
    _c("div", { staticClass: "tab-thumbnail-switcher-image-container" }, [
      _c("img", {
        attrs: {
          height: "443",
          width: "443",
          src: _vm.resizeImageSrc(0, "443x443"),
          srcset:
            _vm.resizeImageSrc(_vm.mediaIndex, "443x443") +
            " 1x, \n                " +
            _vm.resizeImageSrc(_vm.mediaIndex, "886x886") +
            " 2x",
          loading: "eager",
          alt: _vm.getMediaAlt(_vm.mediaIndex)
            ? _vm.getMediaAlt(_vm.mediaIndex)
            : _vm.product.title
        }
      })
    ]),
    _vm._v(" "),
    _c("div", {
      staticClass: "tab-thumbnail-switcher-tablet-right-image",
      style: _vm.getMediaStyle(_vm.sectionSettings.tabletImage, "1000x")
    }),
    _vm._v(" "),
    _vm.sectionSettings.showSwitcher
      ? _c(
          "div",
          { staticClass: "tab-thumbnail-switcher-media" },
          _vm._l(_vm.product.media, function(media, index) {
            return _c("div", {
              key: index,
              staticClass: "tab-thumbnail-switcher-media-image lazyload",
              class: { active: index == _vm.mediaIndex },
              style: _vm.getMediaStyle(media.src, "154x154"),
              on: {
                click: function($event) {
                  return _vm.setMediaIndex(index)
                }
              }
            })
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }